import { render, staticRenderFns } from "./responsibleListItem.vue?vue&type=template&id=1ab62a30"
import script from "./responsibleListItem.vue?vue&type=script&lang=ts"
export * from "./responsibleListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports